export function checkScopeValidity(scope) {
  if (typeof scope === 'string') {
    if (scope !== scope.toLowerCase()) console.error('drag+drop scope must not contain uppercase chars! [' + scope + ']');
  } else {
    scope.forEach(singleScope => {
      if (singleScope !== singleScope.toLowerCase()) console.error('drag+drop scope must not contain uppercase chars! [' + singleScope + ']');
    });
  }
}